angular
  .module('fca-used')
  .component('wishlist', {
    bindings: {
      data: '<'
    },
    templateUrl: 'app/wishlist/wishlist.html',
    controller: wishlistController
  });

wishlistController.$inject = ['wishlist'];
function wishlistController(wishlist) {
  var self = this;
  self.wishlist = wishlist;
}
